/**
 * @name blockquote_node
 */
export const blockquote = {
  content: '(paragraph | unsupportedBlock)+',
  group: 'block',
  defining: true,
  selectable: false,
  parseDOM: [{
    tag: 'blockquote'
  }],

  toDOM() {
    return ['blockquote', 0];
  }

};